import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';

@Component({
  selector: 'sm-view-attendance',
  templateUrl: './view-attendance.component.html',
  styleUrls: ['./view-attendance.component.scss']
})
export class ViewAttendanceComponent implements OnInit,OnDestroy {
 attendanceData:any = []
 apisub: Subscription
 loader: boolean = false
 constructor( private navservice:NavigationService,
    private _apiservice:ApiService, private loaderservice: LoaderServiceService, private route: ActivatedRoute, ) {
      this.navservice.hideSidebarAndNav = false;

      this.apisub = this._apiservice.apiResult.subscribe(resdata => {
        if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_MEMBER_ATTENDANCE_BY_ENTITY){
          this.attendanceData = []
          if(resdata.result){
            this.attendanceData = resdata.result
            this.attendanceData.forEach((element:any) => {
              // if(!element.notes || element.notes == 'null'){
              //   element.notes = '---'
              // }
              if(element.attendance_status == 0){
                element.at_status = 'Absent'
              }
              if(element.attendance_status == 1){
                element.at_status = 'Present'
              }
            });
          }
          this.loaderservice.showLoader = false
          this.loader = false
        }
      })
     }
     entityHash:any
     memberHash:any
     pt:any
  ngOnInit(): void {
    this.route.queryParams.subscribe(data => {
      if(data){
        this.entityHash = data.entityHash
        this.memberHash = data.memberHash
        this.pt = 'Attendance'
      }
    })
    this.loader = true
    this.loaderservice.showLoader = true
    this._apiservice.getMemberAttendanceByEntity(this.entityHash,this.memberHash)
  }


  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
  openGoogleMaps(rowvalue:any): void {
    if(rowvalue.lat && rowvalue.lng){
      // Construct the Google Maps URL with the provided coordinates
      const mapUrl = `https://www.google.com/maps?q=${rowvalue.lat},${rowvalue.lng}`;

      // Sanitize the URL to make it safe for opening in a new tab
      // const sanitizedUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(mapUrl);
      // console.log(sanitizedUrl.toString());

      // Open a new tab with the Google Maps URL
      window.open(mapUrl, '_blank');

    }
  }
}
